module.exports = __webpack_public_path__ + "static/couple-on-patio.4022ea2c.webp";